import React, { Component } from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TpLocationSearchParams from './TpLocationSearchParams';
import TpLocationItem from '../../../Domain/TpLocationItem';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import TpLocationService from '../../../Services/TpLocationService';

export default class TpLocationAdmin extends Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      // Deep-link seed for global record search (CD-5425). REPLACES the search item deliberately:
      // TpLocationSearchParams defaults LinkedToCaspianClient = true, which hides locations that are
      // not linked to a Bravo client. Extending the defaults would mean a deep link to an unlinked
      // location - exactly the kind the palette is best at surfacing - landed on an empty grid.
      searchItem: new URLSearchParams(window.location.search).get('ThirdPartyLocationName')
        ? { ThirdPartyLocationName: new URLSearchParams(window.location.search).get('ThirdPartyLocationName') }
        : new TpLocationSearchParams(),
      selectedItem: null,
      shownPanel: ShownPanelsEnum.None,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.panelOnClose = this.panelOnClose.bind(this);
  }

  showPanel(panelId) {
    if (panelId === ShownPanelsEnum.Refresh) {
      panelId = ShownPanelsEnum.None;
    }
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  panelOnClose() {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    this.refresh();
  }

  render() {
    return (
      <div className='contentwrapper'>
        <TabOfDataTable
          clickOnStartSearch={this.startSearch}
          searchParamsType={TpLocationSearchParams}
          searchItem={this.state.searchItem}
          showSearchStrip={true}
          serviceFunction={TpLocationService.GetAllItemBySearching}
          convertDBItemsFunction={TpLocationService.ConvertDBItems}
          shownPanel={this.state.shownPanel}
          type={TpLocationItem}
          popupEnabled={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in name, code...'
          errorCode='TPLA161'
        />
      </div>
    );
  }
}
